/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SkillsPreviewSelector_company$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PersonSkillModal_company$ref: FragmentReference;
declare export opaque type PersonSkillModal_company$fragmentType: PersonSkillModal_company$ref;
export type PersonSkillModal_company = {|
  +skillLevelsEnabled: ?boolean,
  +person: ?{|
    +id: string,
    +fullName: ?string,
    +skillPersons: ?$ReadOnlyArray<?{|
      +skill: ?{|
        +id: string
      |},
      +level: ?{|
        +id: string,
        +description: ?string,
        +level: ?number,
      |},
    |}>,
  |},
  +$fragmentRefs: SkillsPreviewSelector_company$ref,
  +$refType: PersonSkillModal_company$ref,
|};
export type PersonSkillModal_company$data = PersonSkillModal_company;
export type PersonSkillModal_company$key = {
  +$data?: PersonSkillModal_company$data,
  +$fragmentRefs: PersonSkillModal_company$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "personId",
      "type": "ID!"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PersonSkillModal_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "skillLevelsEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "personId"
        }
      ],
      "concreteType": "Person",
      "kind": "LinkedField",
      "name": "person",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fullName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SkillPerson",
          "kind": "LinkedField",
          "name": "skillPersons",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Skill",
              "kind": "LinkedField",
              "name": "skill",
              "plural": false,
              "selections": [
                (v0/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "SkillLevel",
              "kind": "LinkedField",
              "name": "level",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "description",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "level",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SkillsPreviewSelector_company"
    }
  ],
  "type": "Company"
};
})();
// prettier-ignore
(node/*: any*/).hash = 'adb56feb893c23f646a7426ebb0bfa04';

module.exports = node;
